module.exports = {
      id: "ic-marketbear-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-marketbear-usage",
      toString: function () {
        return this.url;
      }
    }